module.exports = __webpack_public_path__ + "static/media/fundingsource.b79575aa.svg";